export default __webpack_public_path__ + "static/media/DizbuzzIcon.b3a1407e.svg";